module.exports = __webpack_public_path__ + "fonts/HKNova-Light.5b6e46b4.woff2";